import { storyblokEditable } from "@storyblok/react"
import { Text, Button } from "iq-blueberry"
import Img from "@mkt/ui/components/common/Img"

import useCardsFeatured from "./hook.js"
import * as S from "./styles.js"
import Conditional from "@mkt/ui/components/common/Condition/index.js"
import assertAssetURL from "@mkt/utils/assertAssetUrl.js"

const CardsFeatured = ({ blok }) => {
  const { handleProductClick } = useCardsFeatured({ highlights: blok.body })
  return (
    <Conditional condition={blok?.body.length > 0}>
      <div {...storyblokEditable(blok)} className="cards-featured">
        <div css={S.holder}>
          <Text
            as="h3"
            defaultColor="subtitle"
            variant="heading-three"
            css={S.title}
          >
            {blok?.title}
          </Text>
          <div css={S.boxes} data-scroll="productListViewed">
            {blok?.body?.map((product, index) => {
              const parsedContent = product?.node?.content
                ? JSON.parse(product?.node?.content)
                : null
              const data = parsedContent || product.content

              if (!data.title) return

              return (
                <div
                  {...storyblokEditable(product)}
                  css={S.box}
                  key={product.id}
                  data-position={index}
                  data-scroll="productViewed"
                >
                  <div>
                    {product.slug === "neon" && (
                      <div css={S.highlightTag}>
                        <strong>Limite liberado de R$ 🔥🔥🔥</strong>
                        Peça já e descubra o valor
                      </div>
                    )}
                    <div>
                      <Img
                        alt={`Cartão ${data?.title}`}
                        css={S.image}
                        height="88px"
                        src={assertAssetURL(data?.image?.filename)}
                        width="170px"
                      />
                    </div>
                    <Text
                      as="h4"
                      defaultColor="subtitle"
                      variant="heading-four"
                    >
                      {data?.title}
                    </Text>
                    <div css={S.benefitsWrapper}>
                      <div css={S.benefit}>
                        <Text
                          as="span"
                          defaultColor="common"
                          variant="body-small"
                          weight="600"
                        >
                          Renda Mínima:
                        </Text>
                        <Text
                          as="span"
                          defaultColor="subtitle"
                          variant="body-medium"
                          weight="400"
                        >
                          {data?.minimum_income}
                        </Text>
                      </div>
                      <div css={S.benefit}>
                        <Text
                          as="span"
                          defaultColor="common"
                          variant="body-small"
                          weight="600"
                        >
                          Anuidade:
                        </Text>
                        <Text
                          as="span"
                          defaultColor="subtitle"
                          variant="body-medium"
                          weight="400"
                        >
                          {data?.annuity}
                        </Text>
                      </div>
                    </div>
                  </div>

                  <Button
                    onClick={() => handleProductClick(product, index)}
                    expand="x"
                    justify="center"
                  >
                    Continuar
                  </Button>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Conditional>
  )
}

export default CardsFeatured
